<mat-card *ngIf="!!profile">
  <div class="half-width-inputs">
    <smart-input [model]="profile" key="email" translationPrefix="myUsers"></smart-input>
    <div class="or">/</div>
    <smart-input [model]="profile" key="mobile" translationPrefix="myUsers"></smart-input>
  </div>
  <div class="half-width-inputs">
    <smart-input [model]="profile" key="channel" translationPrefix="myUsers.channel"></smart-input>
    <smart-input [model]="profile" key="isDeskWorker" translationPrefix="myUsers"></smart-input>
  </div>
  <div class="half-width-inputs">
    <smart-input [model]="profile" key="firstName" translationPrefix="myUsers"></smart-input>
    <smart-input [model]="profile" key="lastName" translationPrefix="myUsers"></smart-input>
  </div>
  <div *ngIf="errorMessage?.message && !errorMessage.key"
       class="error-message">{{ 'myUsers.errors.' + errorMessage?.message | translate }}
  </div>
</mat-card>

<mat-card *ngIf="!!additionalProfileData" class="additional-profile-data">
  <mat-card-title>{{ 'myUsers.additionalProfileData' | translate }}</mat-card-title>
  <div class="container">
    <div class="input" *ngFor="let key of additionalFieldKeys">
      <smart-input [model]="additionalProfileData.data" [key]="key" [fieldConfig]="additionalFieldConfig[key]">
        <div *ngIf="errorMessage?.key === key" class="error-message down">
          {{ 'myUsers.errors.additionalFields.' + errorMessage?.message | translate }} {{ additionalFieldConfig[key].translations.de.title }}
        </div>
      </smart-input>
      <button mat-icon-button (click)="additionalProfileData.data[key] = null">
        <mat-icon>delete</mat-icon>
      </button>
    </div>
  </div>
</mat-card>

<ng-container *ngIf="!!itemId">
  <data-table *ngIf="groups?.length && isGroupAdmin" [columns]="groupColumns" [headerButtons]="headerButtonsGroup"
              (remove)="removeGroup($event)" [hideSearch]="true" [newHeader]="true" [plainData]="(activeGroups || [])"
              [title]="'userAdmin.profile.assigned' | translate"></data-table>

  <data-table *ngIf="addressbooks?.length && isAddressbookAdmin" [columns]="groupColumns" [headerButtons]="headerButtonsAddressbook"
              (remove)="removeGroup($event, 'addressbooks')" [hideSearch]="true" [newHeader]="true" [plainData]="(activeAddressbooks || [])"
              [title]="'userAdmin.profile.assignedAddressbooks' | translate"></data-table>
</ng-container>

<div class="buttons">
  <button (click)="abort()" class="ibexfusion-raised-button" mat-button>{{ 'general.cancel' | translate }}</button>
  <button (click)="save()" class="ibexfusion-raised-button" mat-button>{{ 'general.save' | translate }}</button>
</div>
